import mainLogo from '../../images/Carburgo/carburgo_logo_color.webp';
import squareLogo from '../../images/Carburgo/vw_logo_square_small_Color.png';
import bannerLogoWhite from '../../images/Carburgo/carburgo_logo_white_large.webp';
import banner01 from '../../images/Carburgo/carburgo_bg_02.webp';
import banner02 from '../../images/Carburgo/carburgo_bg_01.webp';
import banner03 from '../../images/Carburgo/carburgo_bg_aboutUs.webp';
import car123 from '../../images/Carburgo/123_golf.jpg';
import box123 from '../../images/Carburgo/123_vw.jpg';
import {SliderProducts} from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'Carburgo',
    defaultStoreLink: 'ecommerce.carburgo.com.br',
    defaultContactEmail: 'telepecas9@carburgo.com.br',
    whatsappNumber: '51 3594 9429',
    CNPJname: 'Carburgo Veiculos LTDA',
    CNPJ: '91.667.618/0001-65',
    CNPJaddress: 'Avenida Coronel Frederico Linck 240 - Rio Branco, Novo Hamburgo RS - 93336-001',
    launchDate: '01/09/2025',

    multiContact: {},
    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        'volkswagen',
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "SAVOL VW CENTRO",
        "BELCAR VW",
        "REVEMAR VW",
        "DISCAUTOL VW CARANDA",
        "REVEMAR VW PARAUAPEBAS",
        "VECOL VW",
        "UMUARAMA VW ARAGUAINA",
        "UMUARAMA VW ITUMBIARA",
        "RECREIO BH VW",
        "RECREIO RJ VW",
        "LUSON VW",
        "LUSON VW TARUMA",
        "EUROKRAFT VW NOVA FRIBURGO",
        "BARIGUI BLUSA VW",
        "BARIGUI CABRAL VW",
        'APIA VW',
        "BARIGUI VW - SAO JOSE (MATRIZ)",
        "UMUARAMA VW CATALAO",
        "ALEMANHA VW",
        "VIVA VW MACEIO",
        "ESTILO VW - POUSO ALEGRE",
        "DOKAR VW - PINDAMONHANGABA",
        "RECREIO VW MG - MILA",
        "COMERI VW",
        "BREITKOPF VW BLUMENAU",
        "PAMPEIRO VW - SANTA MARIA",
        "BEVEL VW - MARAU",
        "CARRERA ACELERA VW",
        "PAMPA VW MATRIZ",
        "CARAIGÁ VW MORUMBI",
    ],

    disabledSellers: [],

    useMktNames: true,

    endYear: 2025,
    startYear: 1996,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            600: 4,
            800: 5,
            1200: 6,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.Kits
        },
        {
            name: 'Óleos',
            img: 'tabOleos',
            products: SliderProducts.Oleos
        },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.Filtros
        },
        {
            name: 'Luzes',
            img: 'tabLuzes',
            products: SliderProducts.Luzes
        },
        {
            name: 'Acessórios',
            img: 'tabAcessorios',
            products: SliderProducts.Acessorios
        },
    ]
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogo,
    bannerLogoWhite: bannerLogoWhite,

    banner01: banner01,
    banner02: banner02,
    banner03: banner03,
    bannerBrands: '',
    aboutUsBg: banner03,

    box123: box123,
    car123: car123,
    
    paymentImg: squareLogo,
    paymentImgMobile: squareLogo,

    bannerSpecial: '',
    bannerSpecialMobile: '',
    imgSepcial: '',
    imgSepcialMobile: '',

    bannerHighlight: 'Compre peças originais <span style="font-weight: bold;">Volkswagen</span> direto das concessionárias <span style="font-weight: bold;">Carburgo</span>.',
    aboutUs: {
        title: 'Quem Somos',
        content: [
            'Carburgo Volkswagen: Tradição, Qualidade e Compromisso no Rio Grande do Sul',
            'Fundada em 1962, a Carburgo Volkswagen se orgulha de oferecer o melhor negócio e os melhores serviços da marca no estado. Ao longo de mais de 60 anos de história, a Carburgo se consolidou como referência no mercado automotivo gaúcho, sempre com foco no crescimento e na satisfação dos clientes.',
            'Atuando no mercado de automóveis, tornando-se referência em vendas de carros das marcas Volkswagen. Excelência nos padrões de atendimento e qualidade dos produtos sempre guiaram a empresa, que tem como colaboradores uma verdade família focada na satisfação dos clientes.',
            'Além de toda linha Volkswagen, a concessionária também se destaca pela qualidade, volume e seleção do estoque de carros seminovos revisados com garantia e procedência.',
            'Hoje, a Carburgo VW está presente em 6 concessionárias estrategicamente localizadas nas cidades de Novo Hamburgo, São Leopoldo, Sapiranga, Gravataí e Caxias do Sul, contando com uma equipe de mais de 300 profissionais especializados e dedicados a oferecer uma experiência única de vendas e pós-vendas.'
        ],
        link: 'https://www.carburgo.com.br/quem-somos',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/carburgovw/',
        Facebook: 'https://www.facebook.com/Carburgo.Volkswagen',
        LinkedIn: '',
        Youtube: 'https://www.youtube.com/@grupocarburgo',
        Twitter: '',
    },

    footerContent: [],
}